import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import {
  INITIAL_VESSEL_PARTICULARS_STORE_STATE,
  VesselParticularsStoreState,
} from '@navstation-portal/vessels/data-model/vessel';
import { signalStore, withState } from '@ngrx/signals';
import { VESSEL_PARTICULARS_STORE_ID } from './constants';
import { withVesselParticularsEffects } from './with-vessel-particulars-effects';
import { withVesselParticularsReducer } from './with-vessel-particulars-reducer';

export const VesselParticularsStore = signalStore(
  { providedIn: 'root' },
  withDevtools(VESSEL_PARTICULARS_STORE_ID, withGlitchTracking()),
  withState<VesselParticularsStoreState>(INITIAL_VESSEL_PARTICULARS_STORE_STATE),
  withVesselParticularsEffects(),
  withVesselParticularsReducer()
);
